import React, { useState, useEffect } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import { startLoading, doneLoading } from '../../../utils/loading'
import AssetRevolvingFormSearch from './AssetRevolvingFormSearch'
import AssetRevolvingTable from './AssetRevolvingTable'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { cloneDeep } from 'lodash'
import { searchListOfAssets } from '../../../redux/actions/listOfAssets'
import {
  SaveAssetRevolving,
  SearchAssetRevolving,
} from '../../../redux/actions/accountingAssetClosure'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'

export default function AssetRevolvingWidget(props) {
  const { projectCode } = props

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [displayLength, setDisplayLength] = useState(15)
  const [page, setPage] = useState(1)
  const [searchRequest, setSearchRequest] = useState({})
  const [isRefash, setIsRefash] = useState(false)

  const handleSearch = async (pagenumber, pagesize, request) => {
    setIsLoading(true)
    startLoading()
    try {
      console.log(pagenumber, pagesize, request)
      setPage(pagenumber)
      setDisplayLength(pagesize)
      setSearchRequest(request)

      request['pageNumber'] = pagenumber
      request['pageSize'] = pagesize

      const response = await SearchAssetRevolving(request)
      // console.log('response ', response)
      if (response.model) {
        let _schema = cloneDeep(formSchema)

        _schema.result = response.model
        setFormSchema(_schema)
        onRefash()
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSubmit = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await SaveAssetRevolving(request)
      // console.log('response ', response)
      if (response?.model?.successed) {
        onReload(page, displayLength, searchRequest)
      } else {
        notification.open('error', {
          title: response?.model?.Message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    handleSearch(pagenumber, pagesize, searchRequest)
  }

  const onSearch = (request) => {
    handleSearch(1, displayLength, request)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded bordered>
        {formSchema?.searchForm && (
          <div style={{ marginTop: 0 }}>
            <AssetRevolvingFormSearch
              schema={formSchema.searchForm}
              onSearch={onSearch}
              loading={isLoading}
            />
          </div>
        )}

        {!isRefash && (
          <AssetRevolvingTable
            schema={formSchema?.result}
            loading={isLoading}
            page={page}
            displayLength={displayLength}
            disabled={formSchema?.disabled}
            onReload={onReload}
            onSubmit={handleSubmit}
          />
        )}
      </Panel>
    </>
  )
}
